// breadcrumbsModule
window.breadcrumbsModule = (() => {
    function breadcrumbsUiHandling() {
      document.addEventListener('DOMContentLoaded', () => {
        const navigation = document.querySelector('.shopify-block.shopify-app-block nav.breadcrumbs');
        if (navigation) {
          navigation.style.opacity = '0';
          // Add the new elements "arrow back" and "seperator"
          const breadcrumbBack = document.createElement('div');
          breadcrumbBack.classList.add('breadcrumbs__back-navigation');
          breadcrumbBack.innerHTML = `<a class="breadcrumbs__back-navigation-link"><svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
          <g id=".icon">
          <path id="arrow--right" fill-rule="evenodd" clip-rule="evenodd" d="M1.13635 9.03035L8.80302 16.697L9.86368 15.6364L3.47734 9.25002L17 9.25002L17 7.75002L3.42193 7.75002L9.542 1.35177L8.45803 0.31494L1.1247 7.98161L0.617677 8.51168L1.13635 9.03035Z" fill="#7B7B7B"/>
          </g>
          </svg></a><div class="breadcrumbs__back-navigation-seperator"></div>`;
          navigation.prepend(breadcrumbBack);
          // Give the back link the href of the last link
          breadcrumbBack.querySelector('a').href =
            navigation.querySelectorAll('a')[navigation.querySelectorAll('a').length - 1].href;
          // Reset all styles
          // Set parent paddings
          navigation.parentElement.parentElement.style.padding = '0 20px';
          const style = document.createElement('style');
          style.id = 'breadcrumbs-styles';
          style.innerHTML = `
          .breadcrumbs__back-navigation{
            display:flex;
            margin-right: -8px;
            align-items: center;
            flex-shrink:0;
          }
          .breadcrumbs__back-navigation .breadcrumbs__back-navigation-seperator:empty {
            display:block;
          } 
          .breadcrumbs__back-navigation .breadcrumbs__back-navigation-seperator {
            width: 1px;
            height: 16px;
            background: var(--greyscale-Light-Grey, #C0BEBE);
            margin-right: 24px;
            margin-left: 24px;
          }
          .breadcrumbs {
            letter-spacing: 0;
            overflow-x: auto;
            display:flex;
            gap:8px;
            align-items: center;
          }
          .breadcrumbs::-webkit-scrollbar {
            width: 4px; /* Width of the vertical scrollbar */
            height: 4px; /* Height of the horizontal scrollbar */
          }
          .breadcrumbs::-webkit-scrollbar-thumb {
                background-color: #C0BEBE; /* Scrollbar thumb color */
                border-radius: 4px; /* Roundness of the scrollbar thumb */
            }
          .breadcrumbs::-webkit-scrollbar-track {
                background-color: #F4F1EF; /* Scrollbar track color */
                border-radius: 4px;
            }
         
          
          .breadcrumbs ol {
            list-style-type: none;
            margin: 0;
            padding: 0;
          }
          .breadcrumbs li { 
            display: inline-block;
          }
          .breadcrumbs .last-breadcrumb, .breadcrumbs span.last-link , .breadcrumbs span.br-last-link:not([aria-hidden="true"]){
            display:flex;
            color: var(--Dark-grey, #7B7B7B);
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 170%; /* 27.2px */
            flex-shrink:0;
          }
          .breadcrumbs a  {
            flex-shrink:0;
            position: relative;
            transition: 0.3s;
            display:flex;
            color: var(--Dark-grey, #7B7B7B);
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 170%; /* 27.2px */
            text-decoration:none !important;
          }
          .breadcrumbs span{
            display:flex;
            flex-shrink:0;
          }
          .breadcrumbs a:before {
            display:none;
          }
         
          .breadcrumbs ol li:last-of-type {
            pointer-events: none;
          }
          .breadcrumbs ol li:after {
            display:none
          }
          .breadcrumbs [aria-current=page] {
            color: inherit;
            font-weight: initial;
            text-decoration: none;
          }
          .breadcrumbs [aria-current=page],
          .breadcrumbs [aria-current=page]:hover {
            text-decoration: none;
          }
          .breadcrumbs {
            padding: 24px 0;
            text-align: center;
            text-transform: capitalize;
          }
          @media screen and (max-width: 750px) {
            .breadcrumbs {
                padding: 12px 0;
              }
              .breadcrumbs a ,.breadcrumbs span.br-last-link:not([aria-hidden="true"]){
                font-size: 14px !important;
              }
          }
        `;
          document.body.appendChild(style);
          if (navigation) {
            const spans = navigation.querySelectorAll('span:empty, span[aria-hidden="true"]');
            spans.forEach((span) => {
              span.innerHTML = `
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
                <path d="M6 4.93964L9.39256 8.33219C9.4146 8.35421 9.4321 8.38035 9.44403 8.40914C9.45596 8.43792 9.4621 8.46877 9.4621 8.49992C9.4621 8.53108 9.45596 8.56193 9.44403 8.59071C9.4321 8.61949 9.4146 8.64564 9.39256 8.66765L6 12.0602" stroke="#7B7B7B" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              `;
            });
          }
          navigation.style.opacity = '1';
        }
      });
    }
  
    function initBreadcrumbs() {
      breadcrumbsUiHandling();
    }
  
    initBreadcrumbs();
  
    // Public API
    return {
      initBreadcrumbs,
    };
  })();
  